import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getOptimizedImage(url: string | undefined | null, width?: number, height?: number): string {
  if (!url) return '';
  if (url.startsWith('http') && !url.includes('wsrv.nl') && !url.endsWith('.svg') && !url.includes('.svg?')) {
    const w = width || 1080;
    const h = height || 1080;
    return `https://wsrv.nl/?url=${encodeURIComponent(url)}&output=webp&w=${w}&h=${h}&fit=inside`;
  }
  return url;
}
